import { cn } from "@/core/helpers/cn";

type Props = {
  text: string | number;
  text2?: string | number;
  className?: string;
  classNameText1?: string;
  classNameText2?: string;
};

export default function FactionTextBlock({
  text,
  text2,
  className,
  classNameText1,
  classNameText2,
}: Props) {
  return (
    <div
      className={cn(
        "flex justify-center items-center gap-0.5 h-9 py-3 px-3 bg-accent-muted/12 rounded-md",
        className,
      )}
    >
      <div
        className={cn(
          "text-[0.6875rem] font-bold text-accent-solid leading-none uppercase",
          classNameText1,
        )}
      >
        {text}
      </div>
      {(text2 || typeof text2 === "number") && (
        <div
          className={cn(
            "font-bold text-[0.6875rem] text-[#B8B8B8] leading-none uppercase",
            classNameText2,
          )}
        >
          {text2}
        </div>
      )}
    </div>
  );
}
